import { render } from "./cancelLao.vue?vue&type=template&id=5d3877c6&scoped=true"
import script from "./cancelLao.vue?vue&type=script&lang=js"
export * from "./cancelLao.vue?vue&type=script&lang=js"

import "./cancelLao.vue?vue&type=style&index=0&id=5d3877c6&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3877c6"]])

export default __exports__